/* IssueTypeNode.tsx generated by @compiled/babel-plugin v0.38.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
export var IssueTypeNode = function IssueTypeNode(_ref) {
  var IssueTypeField = _ref.IssueTypeField;
  return /*#__PURE__*/React.createElement("img", {
    height: "16",
    width: "16",
    src: IssueTypeField.issueType.avatar.small,
    alt: IssueTypeField.issueType.name
  });
};